export default __webpack_public_path__ + "static/media/arrow-prev.ac4d83e8.svg";